import { PageTitle } from "components/PageMeta/PageTitle";
import { useProductContext } from "../context";
import { pageName } from "constants/pageNames";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid2 as Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import dayjs from "configs/dayjs.config";

import { dateTimeFormat } from "constants/componentsConstants";
import { ProductTopBanner } from "../components/ProductTopBanner";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ImagePreview } from "components/Image/ImagePreview";
import { useGlobalContext } from "context/GlobalContext";
import { message } from "constants/responses/message";
import { useParams } from "react-router-dom";
import { fetchProductFromIdApi } from "API/apis/product/getProductFromId";
import { HiddenContent } from "components/Text/HiddenContent";
import { TimeSince } from "components/DateTime/TimeSince";

export const ProductPreview = () => {
  const { setIsInitializing, setError, setIsLoading, isBdc } =
    useGlobalContext();
  const { setCurrentProject, previewProduct } = useProductContext();
  const [record, setRecord] = useState();
  const [lotDetail, setLotDetail] = useState();
  const { productId } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        const { data, status } = await fetchProductFromIdApi(productId);
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setCurrentProject(data.enquiryId);
        setRecord(data);
        setLotDetail(data.lotProcessing);
        setIsInitializing(false);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [productId]);

  return (
    <>
      <PageTitle pageName={pageName.product.previewProduct} />
      <ProductTopBanner buttonType="back" />
      {record && (
        <Card>
          <CardContent>
            <Box>
              <ImagePreview src={record.refImage} />
            </Box>
            <Grid container spacing={5}>
              <Box>
                <List>
                  <ListItem>
                    <ListItemText
                      primary="Product Code"
                      secondary={record.docCode}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Product Name"
                      secondary={record.productName}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Category"
                      secondary={`${record.productParentCategory}-${record.childParentCategory}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Quantity"
                      secondary={`${record.productQuantity} ${record.productUom}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Delivery Date"
                      secondary={dayjs(record.deliveryDate).format(
                        dateTimeFormat.date
                      )}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Is PCD Required"
                      secondary={record.isPcdRequired ? "Yes" : "No"}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Rate"
                      secondary={`${record.sellingPrice} / ${
                        isBdc && (
                          <HiddenContent>CP-{record.costPrice}</HiddenContent>
                        )
                      }`}
                    />
                  </ListItem>
                  <ListItem>
                    <Link to={record.link} target="_blank">
                      <ListItemText primary="Link" secondary={record.link} />
                    </Link>
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="BDC"
                      secondary={`${record.createdBy} / ${dayjs(
                        record.createdOn
                      ).format(dateTimeFormat.date)}`}
                    />
                  </ListItem>
                </List>
              </Box>
              <Box width={500}>
                <Typography variant="h5">Lot Detail</Typography>
                <Divider />
                <Box>
                  {lotDetail.map((item) => (
                    <Box
                      key={item.lotPartId}
                      backgroundColor={
                        previewProduct.lotPartId === item.lotPartId
                          ? "grey"
                          : ""
                      }
                    >
                      <FlexBox>
                        <Box width={120}>Part Code</Box>
                        <Box>{item.partLotDocCode}</Box>
                      </FlexBox>
                      <FlexBox>
                        <Box width={120}>Part Name</Box>
                        <Box>{item.partCode}</Box>
                      </FlexBox>
                      <FlexBox>
                        <Box width={120}>Quantity</Box>
                        <Box>
                          {item.partQuantity} {record.productUom}
                        </Box>
                      </FlexBox>
                      <FlexBox>
                        <Box width={120}>Deadline</Box>
                        <TimeSince
                          startDate={item.partDeadline}
                          variant="data"
                        />
                      </FlexBox>
                      <Divider />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </CardContent>
        </Card>
      )}
    </>
  );
};
